// main.js
import 'modern-normalize';
// =============Header================
// приховування хедера при скролі
import { initHeaderScrollHide } from './js/components/header/hideHeaderOnScroll.js';
initHeaderScrollHide();
// перемикання між мовами
import './js/services/langToggle.js';
// мобільне меню
import './js/components/burgerMenu/burgerMenu.js';

// ==============Hero================
// Анімація заголовку на головній
import './js/components/hero/scrollHeroTitle.js';

// ==============Our Services================
import './js/components/ourServices/services.js';
import './js/components/ourServices/swiper.js';
import './js/components/ourServices/modals.js';

// ============Trip Planning================
// step 1
import './js/components/tripPlanning/step1/utils/dateTime.js';
import './js/components/tripPlanning/step1/returnTrip.js';
import './js/components/tripPlanning/step1/trip-form.js';
import './js/components/tripPlanning/step1/nextButton.js';
import './js/components/tripPlanning/step1/passengersModal.js';
import './js/components/tripPlanning/step1/verifyPhone.js';
import './js/components/tripPlanning/step1/clearInputs.js';

// step 2
import './js/components/tripPlanning/step2/selectedCars.js';
import './js/components/tripPlanning/step2/carsListScroll.js';
import './js/components/tripPlanning/step2/backButton.js';
import './js/components/tripPlanning/step2/nextButton.js';
import './js/components/tripPlanning/step2/currentCurrency.js';
// Minivan upsell suggestions
// Removed minivan upsell feature

// step 3
import './js/components/tripPlanning/step3/customer-form.js';
import './js/components/tripPlanning/step3/infoOrder.js';
import './js/components/tripPlanning/step3/infoForDriver.js';
import './js/components/tripPlanning/step3/confirmOrder.js';

// =============Error Window================
import './js/components/errorWindow/displayWorkInProgress.js';
// ============Google Consent Mode================
// Consent Manager (має бути першим для Google Consent Mode)
import './js/utils/consentManager.js';

import './js/components/tripPlanning/step3/buttons.js';
import './js/components/tripPlanning/tabsNavigation.js';

// Запуск карти
import { initMap } from './js/googleMaps/map.js';
// Floating contact menu
import './js/components/contactMenu/fabContactMenu.js';
// Testimonials randomizer
import './js/components/testimonials/testimonialsShuffle.js';
// Testimonials slider
import './js/components/testimonials/testimonialsSlider.js';
// Contextualize language menu on specific pages (e.g., airport-transfer)
import './js/services/langMenuContextualize.js';

let mapInitialized = false;

function lazyLoadMap() {
  if (mapInitialized) return;
  mapInitialized = true;
  initMap();
}

// Відкладене завантаження  При скролі до мапи (через IntersectionObserver)
const mapElement = document.getElementById('map');
if (mapElement) {
  const observer = new IntersectionObserver(
    entries => {
      if (entries[0].isIntersecting) {
        lazyLoadMap();
        observer.disconnect();
      }
    },
    { threshold: 0.1 }
  );
  observer.observe(mapElement);
}
